<template>
  <div class="stack-list">
    <Row>
      <Col>
        <Card shadow>
          <div style="float: left">
            <Form :model="searchForm" ref="searchForm" inline :label-width="40" @submit.native.prevent>
              <FormItem label="名称">
                <Input v-model="searchForm.name" style="min-width: 200px" />
              </FormItem>
              <FormItem :label-width="0" class="mob-align-right">
                <Button type="primary" @click="getTableData()">搜索</Button>
                <Button style="margin-left: 8px" @click="searchForm.name = ''">重置</Button>
              </FormItem>
            </Form>
          </div>
          <div style="text-align: right">
            <Button
              @click="$router.push({name: 'container_stack_add'})"
              type="primary"
              icon="md-add">添加堆栈</Button>
          </div>
        </Card>
      </Col>
    </Row>
    <Row :gutter="8">
      <Alert show-icon v-if="!data.length">暂无堆栈数据</Alert>
      <Col :lg="24" v-for="item in data" :key="item.id">
        <Card class="container-stack">
          <div class="container-stack-top">
            <span v-if="item.updated_at">最后修改：{{ moment(item.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </div>
          <div class="container-stack-title">
            <span v-on:click="$router.push({name: 'container_stack_detail', params: {id: item.id}})">{{ item.name }}</span>
            <Tag style="margin-left: 15px" color="blue">{{ item.deploy_type === 'yaml' ? 'YAML' : item.deploy_type === 'template' ? '模板' : item.deploy_type }}</Tag>
          </div>
          <div class="container-stack-summary">
            <div class="container-stack-summary-content">
              <span v-if="item.environments.length">
                <b>全局环境变量 <span style="color: #999">({{ item.environments.length }})</span>：</b>
                <Tag v-for="(envItem, envItemIndex) in item.environments" :key="`envItemIndex_${envItemIndex}`">{{ envItem.envName }}={{ envItem.envValue }}</Tag>
              </span>
              <span v-if="item.deploy_type === 'template' && item.configs.length">
                <br/>
                <b>容器 <span style="color: #999">({{ item.configs.length }})</span>：</b>
                <Tag v-for="(configItem, configItemIndex) in item.configs" :key="`configItemIndex_${configItemIndex}`">{{ configItem.template ? configItem.template.title : '' }}</Tag>
              </span>
              <span v-else-if="item.deploy_type === 'yaml' && item.yaml_config && Object.keys(item.yaml_config).length">
                <br/>
                <b>容器 <span style="color: #999">({{ Object.keys(item.yaml_config).length }})</span>：</b>
                <Tag v-for="(configItem, configValue, configItemIndex) in item.yaml_config" :key="`yamlConfigItemIndex_${configItemIndex}`">{{ configValue }}</Tag>
              </span>
            </div>
          </div>
          <div class="container-stack-footer">
            <div class="container-stack-footer-operate-btn">
              <Button size="small" type="warning" style="margin-right: 5px" @click="$router.push({name: 'container_stack_edit', params: {id: item.id}})">编辑</Button>
              <Poptip
                confirm
                transfer
                title="确定删除此堆栈吗？"
                @on-ok="handleDelete(item.id)"
                ok-text="确认"
                cancel-text="取消"
                placement="bottom">
                <Button size="small" type="error">删除</Button>
              </Poptip>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getContainerStacks, deleteContainerStack } from '@/api/container/stack'
import moment from 'moment'

export default {
  name: 'list',
  data () {
    return {
      moment: moment,
      listError: false,
      searchForm: {
        name: ''
      },
      data: []
    }
  },
  created: function () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      getContainerStacks(this.searchForm).then(res => {
        this.data = res.data
        this.listError = false
      }).catch(res => {
        console.log(res.response)
        this.listError = true
      })
    },
    handleDelete (id) {
      deleteContainerStack(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .container-stack {
    margin-bottom: 8px;
    border-left: 5px solid #19be6b;
    .container-stack-top {
      position: absolute;
      top: 16px;
      right: 16px;
      span {
        color: #999
      }
    }
    .container-stack-title {
      font-size: 28px;
      font-weight: bold;
      span {
        cursor: pointer;
      }
      span:hover {
        color: #108ee9;
      }
    }
    .container-stack-footer {
      margin-top: 12px;
      position: relative;
      .container-stack-footer-operate-btn {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    .container-stack-summary {
      margin-right: 100px;
      .container-stack-summary-content {
        .context {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
</style>
